import { isEmpty, setCSSStyleDeclaration } from '../../../../../utils/helper';
import { TABLE_BASE_STYLES } from '../../../utils/editorStyles.constants';
import { getCellAttrs, setCellAttrs } from '../tableNodes';
export const getTableHeaderNode = options => {
  let extraAttrs = options.cellAttributes || {};
  let cellAttrs = {
    colspan: {
      default: 1
    },
    rowspan: {
      default: 1
    },
    colwidth: {
      default: null
    }
  };
  for (let prop in extraAttrs) cellAttrs[prop] = {
    default: extraAttrs[prop].default
  };
  return {
    content: options.cellContent,
    attrs: cellAttrs,
    tableRole: 'header_cell',
    isolating: true,
    parseDOM: [{
      tag: 'th',
      getAttrs: dom => getCellAttrs(dom, extraAttrs)
    }],
    toDOM(node) {
      const {
        hasInlineStyles
      } = options;
      const dom = document.createElement('th');
      if (hasInlineStyles) setCSSStyleDeclaration(TABLE_BASE_STYLES.tableHeading, dom);
      Object.entries(setCellAttrs(node, extraAttrs)).forEach(_ref => {
        let [key, value] = _ref;
        dom.setAttribute(key, value);
      });
      if (!isEmpty(node.attrs.colwidth)) {
        dom.style.width = node.attrs.colwidth[0] + 'px';
      }
      return {
        dom,
        contentDOM: dom
      };
    }
  };
};